module.exports = __webpack_public_path__ + "static/media/IMG_0286.181412bf.JPG";